import { render, staticRenderFns } from "./OrderDetailView.vue?vue&type=template&id=0790861e&scoped=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=js"
export * from "./OrderDetailView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailView.vue?vue&type=style&index=0&id=0790861e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790861e",
  null
  
)

export default component.exports